import {create} from 'zustand';
import {subscriptionApi} from '../services/api/subscriptionApi';
import {paymentApi} from '../services/api/paymentApi';

export const useSubscriptionStore = create((set) => ({
  plans: [],
  addons: [],
  invoices: [],
  isLoading: false,

  fetchPlans: async () => {
    set({isLoading: true});
    try {
      const response = await subscriptionApi.listPlans();
      set({plans: response.data.data});
      return response.data.data;
    } finally {
      set({isLoading: false});
    }
  },

  fetchAddons: async () => {
    try {
      const response = await subscriptionApi.listAddons();
      set({addons: response.data.data});
      return response.data.data;
    } catch {
      return [];
    }
  },

  subscribe: async (orgUnitId, planVariantId, subscriptionId, paymentMethod) => {
    const response = await subscriptionApi.subscribe(orgUnitId, {
      planVariantId,
      subscriptionId: subscriptionId || null,
      paymentMethod,
    });
    return response.data.data;
  },

  activateSubscription: async (orgUnitId, planVariantId, invoiceId) => {
    const response = await subscriptionApi.activateSubscription(orgUnitId, {
      planVariantId,
      invoiceId,
    });
    return response.data.data;
  },

  renewSubscription: async (subscriptionId, planVariantId, invoiceId) => {
    const response = await subscriptionApi.renewSubscription(subscriptionId, {
      planVariantId,
      invoiceId,
    });
    return response.data.data;
  },

  fetchInvoices: async () => {
    try {
      const response = await subscriptionApi.listInvoices();
      set({invoices: response.data.data});
      return response.data.data;
    } catch {
      return [];
    }
  },

  fetchInvoiceDetail: async (invoiceId) => {
    const response = await subscriptionApi.getInvoiceDetail(invoiceId);
    return response.data.data;
  },

  markInvoicePaid: async (invoiceId) => {
    const response = await subscriptionApi.markInvoicePaid(invoiceId);
    return response.data.data;
  },

  // Easebuzz payment gateway
  initiatePayment: async (orgUnitId, planVariantId, subscriptionId) => {
    const response = await paymentApi.initiatePayment({
      orgUnitId,
      planVariantId,
      subscriptionId: subscriptionId || null,
    });
    return response.data.data;
  },

  verifyPayment: async (txnId) => {
    const response = await paymentApi.verifyPayment({txnId});
    return response.data.data;
  },

  // Bulk renewal - single payment for multiple stores
  bulkInitiatePayment: async (planVariantId, items) => {
    const response = await paymentApi.bulkInitiatePayment({planVariantId, items});
    return response.data.data;
  },
}));
